
import { Policy, Acknowledgment } from "@/types";
import { Dispatch, SetStateAction } from "react";

/**
 * Operations related to policy acknowledgment
 */
export const usePolicyAcknowledgment = (
  user: any,
  policies: Policy[],
  acknowledgments: Acknowledgment[],
  setAcknowledgments: Dispatch<SetStateAction<Acknowledgment[]>>,
  saveToStorage: (updatedPolicies: Policy[], updatedAcknowledgments?: Acknowledgment[]) => void
) => {
  const acknowledgePolicy = (policyId: string) => {
    if (!user) return;
    
    // Get the current version of the policy
    const policy = policies.find(p => p.id === policyId);
    if (!policy) return;

    const newAcknowledgment: Acknowledgment = {
      id: Math.random().toString(36).substr(2, 9),
      userId: user.id,
      policyId,
      acknowledgedAt: new Date().toISOString(),
      versionAcknowledged: policy.version // Store the version being acknowledged
    };

    const updatedAcknowledgments = [...acknowledgments, newAcknowledgment];
    setAcknowledgments(updatedAcknowledgments);
    saveToStorage(policies, updatedAcknowledgments);
  };

  const isPolicyAcknowledged = (policyId: string) => {
    if (!user) return false;
    
    const policy = policies.find(p => p.id === policyId);
    if (!policy) return false;
    
    // Draft policies are not acknowledged
    if (policy.isDraft) return false;
    
    // Check if the user has acknowledged the current version of the policy
    return acknowledgments.some(
      (ack) => ack.userId === user.id && 
              ack.policyId === policyId && 
              ack.versionAcknowledged === policy.version
    );
  };

  return {
    acknowledgePolicy,
    isPolicyAcknowledged
  };
};
